import { AfterViewInit, Directive, ElementRef, EventEmitter, NgZone, OnDestroy, Output } from '@angular/core';
import { Gesture, GestureController } from '@ionic/angular';

// Свайп убік ховає елемент (картку вхідного дзвінка); короткий свайп — картка повертається на місце.
// Жест лише горизонтальний, тож прокрутка сторінки й торкання кнопок працюють як раніше
@Directive({
  selector: '[mobileSwipeDismiss]',
  standalone: true
})
export class SwipeDismissDirective implements AfterViewInit, OnDestroy {
  @Output() readonly mobileSwipeDismiss = new EventEmitter<void>();

  private gesture: Gesture | null = null;

  constructor(
    private el: ElementRef<HTMLElement>,
    private gestureCtrl: GestureController,
    private zone: NgZone
  ) {}

  ngAfterViewInit(): void {
    const el = this.el.nativeElement;
    this.gesture = this.gestureCtrl.create({
      el,
      gestureName: 'swipe-dismiss',
      direction: 'x',
      threshold: 10,
      onStart: () => {
        el.style.transition = 'none';
      },
      onMove: detail => {
        el.style.transform = `translateX(${detail.deltaX}px)`;
        el.style.opacity = String(Math.max(0.2, 1 - Math.abs(detail.deltaX) / el.offsetWidth));
      },
      onEnd: detail => {
        const width = el.offsetWidth;
        const dismiss = Math.abs(detail.deltaX) > width * 0.35 || Math.abs(detail.velocityX) > 0.4;
        el.style.transition = 'transform 0.2s ease-out, opacity 0.2s ease-out';
        if (dismiss) {
          el.style.transform = `translateX(${Math.sign(detail.deltaX || detail.velocityX) * width * 1.2}px)`;
          el.style.opacity = '0';
          setTimeout(() => this.zone.run(() => this.mobileSwipeDismiss.emit()), 200);
        } else {
          el.style.transform = '';
          el.style.opacity = '';
        }
      }
    }, true);
    this.gesture.enable();
  }

  ngOnDestroy(): void {
    this.gesture?.destroy();
  }
}
